export default "__VITE_ASSET__CDqMlLBs__"